/* eslint-disable no-multi-spaces */
import { StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
	// The container that replaces .total_info_table
	totalInfoTable: {
		position: 'relative',
		top: -20, // margin-top: -2rem but margin-top may cause issues.
		minHeight: 12, // avoid issues with empty nodes
		display: 'flex',
		flexDirection: 'column',
		fontSize: 10,
		textTransform: 'uppercase',
		lineHeight: 1.4,
		width: '100%',
	},

	row: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%',
	},

	col1: { flex: 1 }, // ~16.7%
	col2: { flex: 1.5 }, // ~25%
	col3: { flex: 0.33 },
	col4: { flex: 0.33 },
	col5: { flex: 0.5 },
	col6: { flex: 0.5 },
	col7: { flex: 2 },
	col8: { flex: 0.75 },
	col8Wide: { flex: 2 }, // extra space for "Price on request" text
	col9: { flex: 0.05 },
	col9Hidden: { flex: 0, width: 0 },

	// Generic base cell (like .total_info__cell)
	cell: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		paddingHorizontal: 8, // ~0.5rem
		paddingVertical: 4, // ~0.25rem or 0.5rem—adjust as needed
	},

	numericCell: {
		justifyContent: 'flex-end',
	},
	numericText: {
		textAlign: 'right',
	},

	greyGridCell: {
		backgroundColor: '#e6e6e6', // default cell bg
	},

	light: {
		backgroundColor: '#f0f0f0',
	},

	bold: {
		fontWeight: 'bold',
	},

	label: {
		fontWeight: 'normal',
	},
	value: {
		fontWeight: 'bold',
	},

	shrinkBottomMargin: {
		marginBottom: -1, // white line caused by subpixel alignment
	},
	shrinkTopMargin: {
		marginTop: -1, // white line caused by subpixel alignment
	},

	// Row 0: subtotal, material costs
	materialCosts: {
		fontWeight: 'bold',
		textAlign: 'right',
	},

	// Row 1: shipping label, shippingCosts
	// pass

	// Row 2: total_txt empty empty empty empty subtotal_lbl subtotal
	total_txt: {
		backgroundColor: '#456d86', // $blue_2
		color: '#fff',
		fontWeight: 700,
		textAlign: 'center',
		justifyContent: 'center',
	},
	total_txtTop: {
		borderTopLeftRadius: '2px',
	},
	empty: {},
	subtotal_lbl: {
		fontWeight: 'bold',
	},
	subtotal: {
		fontWeight: 'bold',
	},

	// Row 3: total_txt qty qty_unit m2 m2_unit vat_lbl vat
	qty_unit: {
		fontWeight: 700,
	},
	m2_unit: {
		fontWeight: 700,
	},
	vat_lbl: {
		fontWeight: 'normal',
	},

	// Row 4: total_txt kg kg_unit lfm lfm_unit total_lbl total
	total_txtBottom: {
		borderBottomLeftRadius: '2px',
	},
	kg_unit: {
		fontWeight: 700,
	},
	lfm: {
		textAlign: 'right',
		justifyContent: 'flex-end',
	},
	lfm_unit: {
		fontWeight: 700,
	},
	total_lbl: {
		fontWeight: 'bold',
	},
	total: {
		fontWeight: 'bold',
	},

	totalInfoMsg: {
		marginTop: 4,
	},
	totalInfoVolumeDiscount: {
		alignItems: 'flex-end',
		textAlign: 'right',
		fontWeight: 'bold',
		fontSize: 10,
	},
	totalInfoExtraTextFromVolume: {
		textAlign: 'right',
		fontWeight: 'bold',
		fontSize: 10,
		backgroundColor: '#ffd38066',
	},
	totalInfoDelivery: {
		marginTop: 4,
		alignItems: 'flex-end',
		textAlign: 'right',
		fontSize: 8,
	},

	/*
.total_info__volume_discount {
	text-align: left;
	font-weight: bold;
	font-size: 2rem;
	color: $red;
	padding-bottom: 1rem;
}
	*/
});

export default styles;
